var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick",
    clipPath: "url(#clip0_1393_44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.46971 5.85009L0.812892 4.19327C0.626679 4.00705 0.325873 4.00705 0.13966 4.19327C-0.0465533 4.37948 -0.0465533 4.68029 0.13966 4.8665L2.13548 6.86232C2.3217 7.04853 2.6225 7.04853 2.80871 6.86232L7.86034 1.81069C8.04655 1.62448 8.04655 1.32368 7.86034 1.13746C7.67413 0.951249 7.37332 0.951249 7.18711 1.13746L2.46971 5.85009Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1393_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickWhite);
export default __webpack_public_path__ + "static/media/tick_white.b79e132662c2820ef6763d5808b80153.svg";
export { ForwardRef as ReactComponent };